import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { CatalogoServicioModal } from "./CatalogoServicioModal";
import FiltroMultiple from "../../Postventa/Dashboard/Modales/FiltroMultiple";

const ESTADO_VACIO_FILTROS = { lineaVenta: [] };
const ESTADO_VACIO_MOSTRAR = { lineaVenta: { open: false } };

// Catálogo de Servicio — listado de los productos/servicios disponibles para cotizar, con
// alta y edición vía modal (CatalogoServicioModal) y activar/desactivar por estatus.
// Conectado a CotizacionesCRM/Listado, /Guardar, /CambiarEstatus, /ObtenerServicioID.
export const CRM_CatalogoServicio = () => {
  const history = useHistory();
  const [catalogo, setCatalogo] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [idServicioSeleccionado, setIdServicioSeleccionado] = useState(null);
  const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });

  const [options, setOptions] = useState(ESTADO_VACIO_FILTROS);
  const [filtros, setFiltros] = useState(ESTADO_VACIO_FILTROS);
  const [filtrosTemp, setFiltrosTemp] = useState(ESTADO_VACIO_FILTROS);
  const [mostrarFiltro, setMostrarFiltro] = useState(ESTADO_VACIO_MOSTRAR);
  const [prioridadFiltros, setPrioridadFiltros] = useState([]);

  useEffect(() => {
    setOptions({
      lineaVenta: [...new Set(catalogo.map((s) => s.linea_venta).filter(Boolean))].map((v) => ({ value: v, label: v })),
    });
  }, [catalogo]);

  const actualizarPrioridad = (filtro) => {
    setPrioridadFiltros((prev) => {
      const index = prev.indexOf(filtro);
      const nuevasPrioridades = index === -1 ? [...prev, filtro] : prev.slice(0, index + 1);

      setFiltrosTemp((prevTemp) => {
        const limpio = { ...prevTemp };
        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) limpio[key] = [];
        });
        return limpio;
      });

      setFiltros((prevFiltros) => {
        const limpio = { ...prevFiltros };
        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) limpio[key] = [];
        });
        return limpio;
      });

      return nuevasPrioridades;
    });
  };

  const catalogoFiltrado = useMemo(() => {
    let data = [...catalogo];
    prioridadFiltros.forEach((filtro) => {
      if (filtro === "lineaVenta" && filtros.lineaVenta.length > 0) {
        data = data.filter((s) => filtros.lineaVenta.includes(s.linea_venta));
      }
    });
    return data;
  }, [catalogo, filtros, prioridadFiltros]);

  const filtroProps = (field, label) => ({
    label,
    field,
    options: options[field],
    filtros,
    setFiltros,
    filtrosTemp,
    setFiltrosTemp,
    mostrarFiltro,
    setMostrarFiltro,
    actualizarPrioridad,
    setPrioridadFiltros,
  });

  const cargarListado = () => {
    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get("CotizacionesCRM/Listado")
      .then((result) => {
        setCatalogo(Array.isArray(result) ? result : []);
        setLoader((prev) => ({ ...prev, mostrar: false }));
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("CATÁLOGO DE SERVICIO", JSON.stringify(error), "error");
      });
  };

  useEffect(() => {
    cargarListado();
  }, []);

  const handleOpenModalNuevo = () => {
    setIdServicioSeleccionado(null);
    setOpenModal(true);
  };

  const handleOpenModalEditar = (idServicio) => {
    setIdServicioSeleccionado(idServicio);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setIdServicioSeleccionado(null);
    setOpenModal(false);
  };

  const handleGuardado = () => {
    handleCloseModal();
    cargarListado();
  };

  const handleCambiarEstatus = (servicio) => {
    const nuevoEstatus = !servicio.estatus;
    Swal.fire({
      title: nuevoEstatus ? "¿Activar servicio?" : "¿Desactivar servicio?",
      text: nuevoEstatus
        ? "El servicio volverá a estar disponible para cotizar."
        : "El servicio dejará de estar disponible para cotizar.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      setLoader((prev) => ({ ...prev, mostrar: true }));
      request
        .get(`CotizacionesCRM/CambiarEstatus?idServicio=${servicio.id_servicio}&estatus=${nuevoEstatus}`)
        .then(() => {
          setLoader((prev) => ({ ...prev, mostrar: false }));
          cargarListado();
        })
        .catch((error) => {
          setLoader((prev) => ({ ...prev, mostrar: false }));
          Swal.fire("CATÁLOGO DE SERVICIO", JSON.stringify(error), "error");
        });
    });
  };

  return (
    <div className="crm-main-screen">
      <LoaderScreen loader={loader} />
      <div className="crm-body">
        <div className="crm-page rca-screen">
          <div className="crm-module">
            <div className="crm-module-head">
              <div className="crm-head-grid">
                <div className="crm-head-left">
                  <button className="crm-btn-regresar" onClick={() => history.goBack()}>
                    <ArrowBackIcon /> Regresar
                  </button>
                </div>
                <div className="crm-head-center">
                  <p className="crm-module-subtitle">Cotizaciones de Servicio</p>
                  <h1 className="crm-module-title">CATÁLOGO DE SERVICIO</h1>
                </div>
                <div className="crm-head-right">
                  <button className="crmcs-btn-agregar" onClick={handleOpenModalNuevo}>
                    <AddCircleOutlineIcon /> Agregar servicio
                  </button>
                </div>
              </div>
              <div className="crm-head-divider">
                <div className="crm-head-divider-dot" />
              </div>
            </div>

            <div className="crm-home-wrapper crmcs-cotizacion-wrapper">
              <div className="crmcs-cot-tabla-wrap">
                <div className="crmcs-cot-tabla-scroll scroll">
                  <table cellPadding={0} cellSpacing={0}>
                    <thead>
                      <tr>
                        <th>
                          <div className="borde-izq">Nombre</div>
                        </th>
                        <th>
                          <div className="borde-izq">
                            <FiltroMultiple {...filtroProps("lineaVenta", "Línea de venta")} />
                          </div>
                        </th>
                        <th>
                          <div className="borde-izq">Descripción</div>
                        </th>
                        <th>
                          <div className="borde-izq">Precio de lista</div>
                        </th>
                        <th>
                          <div className="borde-izq">Descuento</div>
                        </th>
                        <th>
                          <div className="borde-izq">Impuesto</div>
                        </th>
                        <th>
                          <div className="borde-izq">Estatus</div>
                        </th>
                        <th style={{ color: "transparent" }}>
                          <div className="borde-izq">.</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {catalogoFiltrado.map((s) => (
                        <tr key={s.id_servicio}>
                          <td>{s.nombre_servicio}</td>
                          <td>{s.linea_venta}</td>
                          <td>{s.descripcion}</td>
                          <td>{FormatMoney(s.precio_lista)}</td>
                          <td>{FormatMoney(s.descuento)}</td>
                          <td>{FormatMoney(s.impuesto)}</td>
                          <td>
                            <span className={`crmcs-estatus-pill ${s.estatus ? "cerrada" : "creada"}`}>
                              {s.estatus ? "Activo" : "Inactivo"}
                            </span>
                          </td>
                          <td>
                            <div className="crmcs-catalogo-acciones">
                              <button className="crmcs-btn-icono" onClick={() => handleOpenModalEditar(s.id_servicio)} title="Editar">
                                <EditIcon />
                              </button>
                              <button
                                className={`crmcs-btn-toggle ${s.estatus ? "activo" : "inactivo"}`}
                                onClick={() => handleCambiarEstatus(s)}
                              >
                                {s.estatus ? "Desactivar" : "Activar"}
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CatalogoServicioModal
        open={openModal}
        onClose={handleCloseModal}
        idServicio={idServicioSeleccionado}
        onGuardado={handleGuardado}
      />
    </div>
  );
};
